export default __webpack_public_path__ + "static/media/avatar_21.f1d792f9.png";